const params = new URLSearchParams(window.location.search);
export const noPoll = params.has('no-poll');

/**
 * Message text size in px when the flag is absent: the 2em of the box on
 * the 16px root.
 */
const DEFAULT_MESSAGE_FONT_SIZE = 32;
const MIN_MESSAGE_FONT_SIZE = 16;
/**
 * The largest size at which a message of MAX_LENGTH (256) characters still
 * fits the safe area, measured in Chromium with the name cut at its widest
 * (tests/overlay.spec.ts checks it):
 * all caps fits up to 64px, 128 emoji up to 60, 64 `:yt:` emotes up to 59,
 * `MMMM ` and `⚽ ` repeated up to 57. 56 leaves a pixel or two for other
 * Chromium builds. Spam is cut off at the bottom of the safe area: 256 W's
 * from 51px, 256 one-character emoji such as ⚽ from 43px. So is a long run
 * of CJK, which NRK Sans lacks, at a size that depends on the fallback font.
 */
const MAX_MESSAGE_FONT_SIZE = 56;

/**
 * Message text size in px, `?font-size=48` or `?font-size=48px`, for the
 * studio screen that shows the overlay with `?no-poll`. Clamped to the
 * range above, so a message of the maximum length still fits, spam aside.
 */
export const messageFontSize = parseFontSize(params.get('font-size'));

function parseFontSize(raw: string | null): number {
  if (raw == null) return DEFAULT_MESSAGE_FONT_SIZE;
  const px = raw.trim().replace(/px$/i, '');
  const value = Number(px);
  if (px === '' || !Number.isFinite(value)) {
    console.warn(`Ignoring font-size "${raw}", not a number of px`);
    return DEFAULT_MESSAGE_FONT_SIZE;
  }
  const clamped = Math.min(
    MAX_MESSAGE_FONT_SIZE,
    Math.max(MIN_MESSAGE_FONT_SIZE, value)
  );
  if (clamped !== value) {
    console.warn(`font-size ${value} is out of range, using ${clamped}`);
  }
  return clamped;
}
